module.exports = __webpack_public_path__ + "static/media/SideMenu_Billing.f454e76e.svg";